import React, { Component } from 'react';
import { connect } from "react-redux";
import Dropdown from 'react-dropdown';
import {
    PATTERN_SWITCH,
    SUB_SEQUENCE_VOLUME_CHANGE
} from 'session/constants.js';

function AutomationTypeDropdown(props) {
    function onChange(type) {
        props.subSequence.setAutomationToShow(type);
    }

    return (
        <Dropdown
          className='automation-type-dropdown'
          controlClassName='automation-type-control-dropdown'
          arrowClassName='automation-type-arrow-dropdown'
          options={OPTIONS}
          onChange={(o) => onChange(o.value)}
          value={getOption(props.automationTypeToShow)}
          placeholder="Rate" />
    );
}

const OPTIONS = [
    {value: PATTERN_SWITCH, label: 'Pattern'},
    {value: SUB_SEQUENCE_VOLUME_CHANGE, label: 'Volume'},
];

function getOption(value=PATTERN_SWITCH) {
    return OPTIONS.find(opt => opt.value === value);
}


const mapStateToProps = (state, props) => {
    return {
        automationTypeToShow: state.arrangement.automationTypeToShow[props.subSequence.id],
    };
};
 
export default connect(mapStateToProps, null)(AutomationTypeDropdown);
